import { TranslationLabels } from "translations/TranslationLabels";

export enum AddAgendaItemPositionEnum {
  Last = 0,
  AfterSelected = 1,
}

export function getAddAgendaItemPositionLabel(value: AddAgendaItemPositionEnum, i18n: TranslationLabels): string {
  switch (value) {
    case AddAgendaItemPositionEnum.Last:
      return i18n.AddAgendaItemPosition_Last;
    case AddAgendaItemPositionEnum.AfterSelected:
      return i18n.AddAgendaItemPosition_AfterSelected;
    default:
      return `Unknown AddAgendaItemPositionEnum: ${value}`;
  }
}
